import { Check, Close, Delete, Edit } from "@mui/icons-material"
import { Box, IconButton } from "@mui/material"
import {
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro"
import { deDE } from "@mui/x-data-grid/locales"
import { StyledButton } from "components/Button/StyledButton"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { DeviceDataGroup } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useCallback, useEffect, useState } from "react"
import { AddDeviceDataGroupDialog } from "./AddDeviceDataGroupDialog"
import AdminDeviceData from "./AdminDeviceData"

const AdminDeviceDataGroups = () => {
  const { deviceDataGroups } = useStoreState((state) => state)
  const {
    updateDeviceDataGroup,
    deleteDeviceDataGroup,
    fetchDeviceDataGroups,
  } = useStoreActions((actions) => actions)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<DeviceDataGroup>({
    id: "",
    name: "",
    isDefault: false,
    isAux: false,
    deviceData: [],
  })
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])
  // const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>([]) // Removed

  useEffect(() => {
    fetchDeviceDataGroups()
  }, [fetchDeviceDataGroups])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        id: "NEW",
        name: "",
        isDefault: false,
        isAux: false,
        deviceData: [],
      })
    } else {
      const devData = deviceDataGroups.find((tb) => tb.id === id)
      if (devData) {
        setFormState(devData)
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    deleteDeviceDataGroup(toDelete)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: DeviceDataGroup) => {
    updateDeviceDataGroup(arg)
    setDialogOpen(false)
  }

  const columns = [
    { field: "name", headerName: "Name", width: 150 },
    {
      field: "isDefault",
      headerName: "bei allen Prüfungen anzeigen",
      width: 150,
      renderCell: (params: any) => {
        return params.row.isDefault ? (
          <Check color="success" />
        ) : (
          <Close color="error" />
        )
      },
    },
    {
      field: "isAux",
      headerName: "bei AUX Equipment anzeigen",
      width: 150,
      renderCell: (params: any) => {
        return params.row.isAux ? (
          <Check color="success" />
        ) : (
          <Close color="error" />
        )
      },
    },
  ]

  const getDetailPanelContent = useCallback(
    ({ row }: { row: DeviceDataGroup }) => {
      return (
        <Box sx={{ p: 2, ml: 5 }}>
          <AdminDeviceData deviceData={row.deviceData} deviceDataGroup={row} />
        </Box>
      )
    },
    []
  )

  return (
    <>
      <Box style={{ maxHeight: "calc(100vh - 160px)", width: "100%" }}>
        <DataGridPro
          getRowId={(row) => row.id}
          rows={deviceDataGroups}
          columns={[
            ...columns,
            {
              field: "actions",
              headerName: "Aktionen",
              type: "actions" as const,
              width: 150,
              renderCell: (params) => (
                <>
                  <IconButton
                    size="small"
                    onClick={() => handleEdit(params.row.id)}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDelete([params.row.id])}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </>
              ),
            },
          ]}
          checkboxSelection={false}
          disableMultipleRowSelection={true}
          slots={{
            toolbar: () => (
              <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <StyledButton
                  buttonType="add"
                  onClick={() => handleEdit("NEW")}
                >
                  Hinzufügen
                </StyledButton>

                <GridToolbarQuickFilter />
              </GridToolbarContainer>
            ),
          }}
          // Remove: onRowSelectionModelChange={(value) => { setSelectedRows(value) }}
          getDetailPanelContent={getDetailPanelContent}
          getDetailPanelHeight={() => "auto"}
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        />
      </Box>

      <AddDeviceDataGroupDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
    </>
  )
}

export default AdminDeviceDataGroups
